import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import "./ImpartSec.css";

import CS1C from "../../assets/CS1C.png";
import CS2C from "../../assets/CS2C.png";
import CS2N from "../../assets/CS2N.png";
import CS3N from "../../assets/CS3N.png";
import CS4C from "../../assets/CS4C.png";
import CS5C from "../../assets/CS5C.png";
import CS6N from "../../assets/CS6N.png";
import CS7C from "../../assets/CS7C.png";
import CS8C from "../../assets/CS8C.png";
import CS9N from "../../assets/CS9N.png";
import CS10C from "../../assets/CS10C.png";
import CS11C from "../../assets/CS11C.png";
import CS12C from "../../assets/CS12C.png";
import CS13C from "../../assets/CS13C.png";
import CS14C from "../../assets/CS14C.png";
import CS15C from "../../assets/CS15C.png";
import CS16C from "../../assets/CS16C.png";
import CS17C from "../../assets/CS17C.png";
import CS18C from "../../assets/CS18C.png";
import CS19C from "../../assets/CS19C.png";
import CS20C from "../../assets/CS20C.png";
import CS21C from "../../assets/CS21C.png";
import CS22C from "../../assets/CS22C.png";
import CS23C from "../../assets/CS23C.png";
import CS24C from "../../assets/CS24C.png";

/* ========================================
   CASE STUDIES
======================================== */

const projects = [
  {
    slug: "social-security-law",
    category: "Social Security Disability",
    title: "Social Security Disability Law Firm",
    result: "-59% cost per lead",
    highlight: "Cost per lead reduced from $118 to $47.81",
    description:
      "Optimized Google Ads to increase qualified leads from 113 to 131 while cutting cost per conversion from $118 to $47.81.",
    image: CS1C,
  },

  {
    slug: "drywall-home-repair-services",
    category: "Drywall & Home Repair Services",
    title: "Salem Drywall & Repair Services Company",
    result: "-81% cost per lead",
    highlight: "Cost per conversion reduced from $208 to $40.22",
    description:
      "Optimized Google Ads to increase qualified leads from 18 to 149 while cutting cost per conversion from $208 to $40.22.",
    image: CS2C,
  },

  {
    slug: "najam-al-wali-furniture",
    category: "Furniture & Home Furnishing",
    title: "Najam Al Wali Furniture & Interiors",
    result: "+379% more leads",
    highlight: "Conversions increased from 222 to 1,060 in three months",
    description:
      "Optimized Google Ads to increase qualified conversions from 222 to 1,060 while cutting cost per conversion from Rs 802 to Rs 342.",
    image: CS3N,
  },

  {
    slug: "atoz-furniture",
    category: "Used Furniture & Home Decor · India",
    title: "A to Z Used Furniture & Home Decor",
    result: "-50% cost per lead",
    highlight: "Cost per conversion reduced from Rs 716 to Rs 358",
    description:
      "Optimized Google Ads to increase qualified conversions from 443 to 1,020 while cutting cost per conversion from Rs 716 to Rs 358.",
    image: CS4C,
  },

  {
    slug: "shah-sawood",
    category: "Shah Sawood",
    title: "Shah Sawood",
    result: "-28% cost per conversion",
    highlight: "Cost per conversion reduced from Rs 476 to Rs 343",
    description:
      "Optimized Google Ads to increase qualified conversions from 317 to 1,100 while cutting cost per conversion from Rs 476 to Rs 343.",
    image: CS5C,
  },

  {
    slug: "metro-mobile",
    category: "Mobile Locksmith Services",
    title: "Metro Mobile Locksmith",
    result: "-31% cost per phone call",
    highlight: "Cost per phone call reduced from $118 to $81.61",
    description:
      "Optimized Google Ads to increase qualified phone leads from 7 to 45 while cutting cost per phone call from $118 to $81.61.",
    image: CS6N,
  },

  {
    slug: "goodworth-furniture",
    category: "Furniture",
    title: "Goodworth Furniture",
    result: "-20% cost per conversion",
    highlight: "Cost per conversion reduced from Rs 448 to Rs 358",
    description:
      "Optimized Google Ads to increase conversions from 1,120 to 1,500 while cutting cost per conversion from Rs 448 to Rs 358.",
    image: CS7C,
  },

  {
    slug: "ez-phone-fix",
    category: "Phone Repair Services",
    title: "EZ Phone Fix",
    result: "+85% phone call leads",
    highlight: "Phone call leads increased from 166 to 307",
    description:
      "Optimized Google Ads to increase phone call leads from 166 to 307 while scaling clicks from 1.09K to 2.02K.",
    image: CS8C,
  },

  {
    slug: "synergy-homecare",
    category: "In-Home Care Services",
    title: "SYNERGY HomeCare",
    result: "+550% phone call leads",
    highlight: "Phone call leads increased from 8 to 52",
    description:
      "Optimized Google Ads to increase phone call leads from 8 to 52 while improving click-to-call rate from 6.9% to 24.5%.",
    image: CS9N,
  },
  {
    slug: "big-city-towing",
    category: "Towing & Roadside Assistance",
    title: "Big City Towing",
    result: "+89% phone call leads",
    highlight: "Phone calls increased from 279 to 526",
    description:
      "Optimized Google Ads to increase phone calls from 279 to 526 while expanding impressions and clicks and maintaining a strong click-to-call rate.",
    image: CS10C,
  },
  {
    slug: "cosma-lab",
    category: "Google Ads Case Study",
    title: "Cosma Lab",
    result: "+317% conversions",
    highlight: "Conversions increased from 102 to 425",
    description:
      "Optimized Google Ads to increase conversions from 102 to 425 while reducing cost per conversion from $5.43 to $2.99 and improving conversion rate from 1.04% to 9.20%.",
    image: CS11C,
  },
  {
    slug: "dead-on-roofing",
    category: "Roofing Services",
    title: "Dead On Roofing",
    result: "+13,300% phone calls",
    highlight: "Phone calls increased from 1 to 134",
    description:
      "Optimized Google Ads to increase phone calls from 1 to 134 while reducing average CPC from $24.79 to $13.62.",
    image: CS12C,
  },
  {
    slug: "emirate-visa-services",
    category: "Visa Services",
    title: "Emirate Visa Services",
    result: "+241% conversion value",
    highlight: "Conversion value increased from dh 227.4K to dh 774.7K",
    description:
      "Optimized Google Ads to increase conversion value from dh 227.4K to dh 774.7K while expanding impressions from 75.2K to 207K and clicks from 9.93K to 24.1K.",
    image: CS13C,
  },
  {
    slug: "safety-training-seminars-bayareacpr",
    category: "CPR & Safety Training",
    title: "Safety Training Seminars – BayAreaCPR",
    result: "-44% cost per conversion",
    highlight: "Cost per conversion dropped from $34.41 to $19.29",
    description:
      "Optimized Google Ads to reduce ad spend by 44% while maintaining nearly the same conversion volume and lowering cost per conversion from $34.41 to $19.29.",
    image: CS14C,
  },
  {
    slug: "volts-electric",
  
    category: "Google Ads Case Study",
  
    title: "Volts Electric",
  
    result: "94 Phone calls",
  
    highlight:
      "Generated 94 phone calls from July 1st – September 18th, 2025",
  
    description:
      "Optimized Google Ads with accurate conversion tracking, high-intent keyword targeting, campaign restructuring, negative keywords, and call-focused optimization to generate 94 qualified phone leads.",
  
    image: CS15C,
  },
  {
    slug: "car-detailing",
  
    category: "Google Ads Case Study",
  
    title: "Sprinter Car Detailing",
  
    result: "12.13x ROAS",
  
    highlight:
      "Achieved a 12.13x ROAS with 127 phone calls and 86.97 conversions in August 2025",
  
    description:
      "Optimized Google Ads with a proper landing page, accurate conversion tracking, high-intent keyword targeting, and conversion-focused bidding to generate stronger leads and calls for a San Diego car detailing company.",
  
    image: CS16C,
  
  },
  
  {
    slug: "plumbing-services",
    category: "Google Ads Case Study",
    title: "XYZ Plumbing Services",
    result: "1.4k Phone Calls",
    highlight:
      "Generated 17,200 leads and 1,460 phone calls with a $46,200 total spend from Jan 2024 to Jul 2025.",
    description:
      "Optimized Google Ads with segmented campaigns, call-only ads, negative keywords, and seasonal bid adjustments to improve lead quality and phone call volume for a local plumbing company.",
    image: CS17C,
  },
  
  {
    slug: "hvac-solutions",
    category: "Google Ads Case Study",
    title: "ABC HVAC Solutions",
    result: "1.4k Phone Calls",
    highlight:
      "Generated 1,460 conversions and 1,340 phone calls with a $29,800 total spend from Jul 2024 to Jul 2025.",
    description:
      "Optimized Google Ads and Facebook campaigns with service-based segmentation, emergency HVAC targeting, and local visibility improvements to drive consistent leads and calls for a residential and commercial HVAC company.",
    image: CS18C,
  },
  
  {
    slug: "rainy-tight-roofing",
    category: "Google Ads Case Study",
    title: "Rainy Tight Roofing",
    result: "130% Lead Growth & 80% CPA Drop",
    highlight:
      "Generated 95 conversions from 1.91K clicks at a $21.69 cost per conversion, achieving a 130% increase in qualified leads and 80% lower CPA within 30 days.",
    description:
      "Optimized Google Ads and website tracking for a U.S.-based roofing company to improve lead quality, reduce acquisition costs, and scale performance through high-intent search campaigns and conversion-focused landing pages.",
    image: CS19C,
  },
  
  {
    slug: "trotter-car-showroom",
    category: "Google Ads Case Study",
    title: "Trotter Car Showroom",
    result: "110% Sales Growth & 70% CPA Drop",
    highlight:
      "Generated 443 conversions from 4.46K clicks with a $19.1K conversion value and $5.9K spend, achieving 110% higher sales and 70% lower CPA in 30 days.",
    description:
      "Optimized Google Ads with Search, Shopping, and Performance Max campaigns to drive eCommerce growth, improve ROAS, and scale online sales for a U.S.-based automotive parts retailer.",
    image: CS20C,
  },
  
  {
    slug: "ramos-furniture",
    category: "Google Ads Case Study",
    title: "Ramos Furniture",
    result: "80% Sales Growth & 40% CPA Drop",
    highlight:
      "Generated $50K in conversion value from 2.03K clicks and 24.6K impressions at a $3.68K spend, achieving 80% higher sales and 40% lower CPA in 30 days.",
    description:
      "Optimized Google Ads with Search, Shopping, and Performance Max campaigns to drive eCommerce growth, improve ROAS, and scale online sales for a U.S.-based furniture retailer.",
    image: CS21C,
  },
  {
    slug: "dubai-desert-safari",
    category: "Google Ads Case Study",
    title: "Dubai Desert Safari",
    result: "80% Lead Growth & 30% Booking Increase",
    highlight:
      "Generated 6.37K conversions from 9.59K clicks at AED 13.32 cost per conversion, achieving 80% higher leads and 30% more bookings with optimized Google Ads campaigns.",
    description:
      "Optimized Google Ads with targeted Search and Local Services campaigns, full conversion tracking, and improved website usability to drive qualified leads and bookings for a UAE-based desert adventure company.",
    image: CS22C,
  },
  {
    slug: "wizard-of-ducts",
    category: "Google Ads Case Study",
    title: "Wizard of Ducts",
    result: "120% Lead Growth & 15% CPA Drop",
    highlight:
      "Generated 838 charged leads (588 phone and 250 message) with $58,741 total spend and 239,714 ad impressions, achieving 120% higher leads and 15% lower CPA.",
    description:
      "Optimized Google Ads with targeted Search and Local Services campaigns, full conversion tracking, and improved website usability to drive qualified leads and calls for a U.S.-based air duct cleaning company.",
    image: CS23C,
  },
  
  {
    slug: "emirates-visa",
    category: "Google Ads Case Study",
    title: "Emirates Visa",
    result: "400% Lead Growth & 25% CPA Drop",
    highlight:
      "Generated 2.64K conversions from 121K clicks at AED 98.58 cost per conversion, achieving 400% higher leads and 25% lower CPA with optimized Google Ads campaigns.",
    description:
      "Optimized Google Ads with segmented Search campaigns, full conversion tracking, and improved website usability to drive qualified visa applications and maximize ROI for a UAE-based travel service provider.",
    image: CS24C,
  },
  
  {
    slug: "charles-farris",
    category: "Google Ads Case Study",
    title: "Charles Farris",
    result: "300% Sales Growth & 25% CPA Drop",
    highlight:
      "Generated 8.13K purchases from 137K clicks with £83.4K total spend and 414K conversion value, achieving 300% higher sales and 25% lower CPA.",
    description:
      "Optimized Google Ads with Search, Brand, and Performance Max campaigns to drive eCommerce growth, improve ROAS, and scale online sales for a luxury British candle brand.",
    image: CS15C,
  },
  
  {
    slug: "vox-city",
    category: "Google Ads Case Study",
    title: "Vox City",
    result: "400% Lead Growth & 45% CPA Drop",
    highlight:
      "Generated 531 conversions from 16.9K clicks at £0.63 average CPC and 10.93% CTR, achieving 400% higher leads and 45% lower CPA.",
    description:
      "Optimized Google Ads with Maximize Clicks and Maximize Conversions bidding strategies, accurate tracking, and improved website usability to drive qualified bookings and scale growth for a UK-based tourism company.",
    image: CS15C,
  },
  
  {
    slug: "rocky-top-plumbing",
    category: "Google Ads Case Study",
    title: "Rocky Top Plumbing & HVAC",
    result: "55% CPL Drop & 25 Leads/Day",
    highlight:
      "Generated 2.38K conversions from 6.47K clicks at $5.95K spend and 84.1K impressions, achieving 55% lower CPL and 20–25 daily leads.",
    description:
      "Optimized Google Ads with improved landing pages, advanced tracking, and refined keyword targeting to reduce costs and scale qualified leads for a U.S.-based plumbing and HVAC company.",
    image: CS15C,
  },
  
  {
    slug: "mitch-wright-plumbing",
    category: "Google Ads Case Study",
    title: "Mitch Wright Plumbing & Heating",
    result: "Scaled to 20 Leads/Day",
    highlight:
      "Generated 1.03M impressions with $3.2K spend and $1.17 cost per conversion, achieving consistent daily leads and strong ROI.",
    description:
      "Optimized Google Ads with a high-converting landing page, advanced tracking setup, and refined keyword targeting to scale lead generation for a U.S.-based plumbing and HVAC company.",
    image: CS15C,
  },
];


/* ========================================
   COMPONENT
======================================== */

const ImpactSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);

  const trackRef = useRef(null);


  /* ========================================
     RESPONSIVE CARD COUNT
  ======================================== */

  useEffect(() => {
    const updateVisibleCards = () => {
      if (window.innerWidth <= 600) {
        setVisibleCards(1);
      } else if (window.innerWidth <= 1000) {
        setVisibleCards(2);
      } else {
        setVisibleCards(3);
      }
    };

    updateVisibleCards();

    window.addEventListener("resize", updateVisibleCards);

    return () => {
      window.removeEventListener("resize", updateVisibleCards);
    };
  }, []);


  /* ========================================
     MAX SLIDER INDEX
  ======================================== */

  const maxIndex = Math.max(
    projects.length - visibleCards,
    0
  );


  /* ========================================
     RESET INDEX
  ======================================== */

  useEffect(() => {
    setCurrentIndex((prev) =>
      Math.min(prev, maxIndex)
    );
  }, [maxIndex]);


  /* ========================================
     MOVE SLIDER
  ======================================== */

  useEffect(() => {
    const track = trackRef.current;

    if (!track) return;

    const cards =
      track.querySelectorAll(".impact-card");

    if (!cards[currentIndex]) return;

    const targetCard = cards[currentIndex];

    track.style.transform =
      `translateX(-${targetCard.offsetLeft}px)`;

  }, [currentIndex, visibleCards]);


  /* ========================================
     HANDLE RESIZE
  ======================================== */

  useEffect(() => {
    const handleResize = () => {
      const track = trackRef.current;

      if (!track) return;

      const cards =
        track.querySelectorAll(".impact-card");

      if (!cards[currentIndex]) return;

      const targetCard = cards[currentIndex];

      track.style.transform =
        `translateX(-${targetCard.offsetLeft}px)`;
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, [currentIndex]);


  /* ========================================
     NEXT SLIDE
  ======================================== */

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex >= maxIndex) {
        return maxIndex;
      }

      return prevIndex + 1;
    });
  };


  /* ========================================
     PREVIOUS SLIDE
  ======================================== */

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex <= 0) {
        return 0;
      }

      return prevIndex - 1;
    });
  };


  const isFirstSlide = currentIndex === 0;
  const isLastSlide = currentIndex === maxIndex;


  return (
    <section className="impact-section">

      <div className="impact-container">

        {/* ========================================
            SECTION HEADER
        ======================================== */}

        <div className="impact-header">

          <div className="impact-heading">

            <p>Proven Results</p>

            <h2>
              Measured in{" "}
              <span>Booked Revenue</span>, not vanity clicks
            </h2>

          </div>


          {/* ========================================
              NAVIGATION
          ======================================== */}

          <div className="impact-navigation">

            <button
              type="button"
              className={`impact-arrow prev-arrow ${
                isFirstSlide ? "disabled" : ""
              }`}
              onClick={prevSlide}
              disabled={isFirstSlide}
              aria-label="Previous case study"
            >
              ‹
            </button>

            <button
              type="button"
              className={`impact-arrow next-arrow ${
                isLastSlide ? "disabled" : ""
              }`}
              onClick={nextSlide}
              disabled={isLastSlide}
              aria-label="Next case study"
            >
              ›
            </button>

          </div>

        </div>


        {/* ========================================
            SLIDER
        ======================================== */}

        <div className="impact-slider">

          <div
            className="impact-track"
            ref={trackRef}
          >

            {projects.map((project, index) => (

              <article
                className="impact-card"
                key={`${project.slug}-${index}`}
              >

                {/* ========================================
                    TOP CONTENT
                ======================================== */}

                <div className="impact-card-content">

                  {/* CATEGORY */}
                  <div className="impact-category">
                    {project.category}
                  </div>


                  {/* TITLE */}
                  <h3 className="impact-card-title">
                    {project.title}
                  </h3>


                  {/* RESULT */}
                  <div className="impact-result">
                    {project.result}
                  </div>



                </div>


                {/* ========================================
                    CASE STUDY IMAGE
                ======================================== */}

                <div className="impact-image-wrapper">

                  <img
                    src={project.image}
                    alt={`${project.title} case study`}
                    className="impact-image"
                    loading="lazy"
                  />

                </div>


                {/* ========================================
                    VIEW CASE STUDY
                ======================================== */}

                <NavLink
                  to={`/case-studies/${project.slug}`}
                  className="case-study-button"
                  aria-label={`Open ${project.title} case study`}
                >

                  <span>
                    View Case Study
                  </span>

                  <span className="case-study-icon">
                    →
                  </span>

                </NavLink>

              </article>

            ))}

          </div>

        </div>

      </div>

    </section>
  );
};

export default ImpactSection;